import React from 'react'
import { useIntl } from 'react-intl'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import Modal from 'LuxKit/Modal/Modal'
import OfferAirportOptions from '../../Airport/OfferAirportOptions'

function OfferCalendarAirportModal() {
  const { resolve } = useModalElementContext<App.AirportLocation | undefined>()
  const intl = useIntl()

  return <Modal
    title={intl.formatMessage({
      id: 'Nmk+0AJgk/',
      defaultMessage: 'Where will you depart from?',
      description: 'Title for airport selection modal on offer page calendar',
    })}
    subtitle={intl.formatMessage({
      id: 'LbdPA4Xf/c',
      defaultMessage: 'Select your preferred airport',
      description: 'Subtitle for airport selection modal on offer page calendar',
    })}
    height="max"
    primaryActionText={intl.formatMessage({
      id: 'CfDWzLkskk',
      defaultMessage: 'Apply',
      description: 'Button text to apply airport selection on offer page calendar',
    })}
  >
    <OfferAirportOptions onSelectAirport={resolve} />
  </Modal>
}

export default OfferCalendarAirportModal
